import { render } from "./StepD.vue?vue&type=template&id=52a663b1"
import script from "./StepD.vue?vue&type=script&lang=js"
export * from "./StepD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__